import { Card, CardActionsProps, CardContent, Grow, Typography } from '@mui/material';
import { AccountType } from '../../models/user';
import { ReactElement } from 'react';
import dayjs from 'dayjs';
import { UserDTO } from '../../generated';

export const UserCard = (props: { user: UserDTO; onClick: () => void; children?: ReactElement<CardActionsProps>; timeout: number }) => {
  const { user, children, onClick } = props;

  return (
    <Grow in={true} timeout={props.timeout}>
      <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }} className="h-100">
        <CardContent onClick={onClick}>
          <Typography variant="h6" color="text.secondary" gutterBottom>
            {props.user?.username}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Email: {props.user.email}
          </Typography>
          <Typography variant="body2">Roles: {props.user?.roles.map((r) => r + ' ') || 'No Description'}</Typography>
          <Typography variant="body2">Account Type: {AccountType[props.user.accountType]}</Typography>
          <Typography variant="caption">Last Login: {user.lastLogin ? dayjs(user.lastLogin).format('DD.MM.YY HH:mm:ss') : '-'}</Typography>
        </CardContent>
        {children}
      </Card>
    </Grow>
  );
};
